import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function confirmSessionAttendance(
  appointmentId: string | number,
  placeValue: string,
  appointmentHeldPlace: string | null,
  cancellationFeeOverride: string | null,
) {
  const response = await fetchOrchidAPI(
    `/api/scheduler/v1/appointment/admin/confirm_attendance/${appointmentId}/${placeValue}`,
    {
      method: "POST",
      body: JSON.stringify({
        place: appointmentHeldPlace,
        cancellation_fee_override: cancellationFeeOverride,
      }),
    },
  );

  if (!response.ok) {
    const responseText = await response.text();
    throw new Error(getErrorDetail(responseText));
  }

  return;
}
